import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './header.css';
// import  assets/img/site-logo.jpg

const Header = () => {
    const [menuOption, setMenuOption] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const toggleMenu = (menuName) => {
        setOpenMenu((prev) => (prev === menuName ? null : menuName));
    };
    return (
        <header className="bleezy-header-area">
            <div className="header-right-overlay"></div>
            <div className="mobile-top-menu">
                <header className="top-header">
                    <div className="menu-header-container">
                        <div className="menu-toggle" onClick={() => setMenuOption(!menuOption)}
                        >
                            &#9776;
                        </div>
                        <div className="contact-area">
                            <div> <i className="fa fa-phone" style={{ fontSize: '15px', marginRight: '10px' }}></i>Call Us(+91) 9454311900</div>
                            <div> <i className="fa fa-envelope" style={{ marginRight: '7px' }}></i> info@octopusssecurity.com</div>
                        </div>
                        <div>
                            <Link to="/">
                                <img src="assets/img/site-logo.jpg" alt="site logo" style={{ height: '50px', width: '50px', borderRadius: '20px' }} />
                            </Link>
                        </div>

                    </div>
                </header>
            </div>
            {menuOption && (
                <div className="sidebar mobile-menu-container">
                    {/* Menu 1 */}
                    <div className="menu-group">
                        <div className="menu-item"> <Link to="/" onClick={() => setMenuOption(false)}>HOME </Link></div>
                    </div>
                    <div className="menu-group">
                        <div className="menu-item"><Link to="/About" onClick={() => setMenuOption(false)}> ABOUT US</Link></div>
                    </div>

                    {/* Security Services  */}
                    <div className="menu-group">
                        <div className="menu-item has-sub" onClick={() => toggleMenu("SecurityServices")}>
                            SECURITY SERVICES <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i>
                        </div>

                        {openMenu === "SecurityServices" && (
                            <div className="submenu">
                                <ul>
                                    <li><Link to="/services/security-guard/" onClick={() => setMenuOption(false)}>Security Guard</Link></li>
                                    <li><Link to="/services/bouncer-and-bodyguard/" onClick={() => setMenuOption(false)}>Bouncer & Bodygruard</Link></li>
                                    <li><Link to="/services/escort-guard/" onClick={() => setMenuOption(false)}>Escort Guard</Link></li>
                                    <li><Link to="/services/event-security/" onClick={() => setMenuOption(false)}>Event Security</Link></li>
                                    <li><Link to="/services/tourist-security/" onClick={() => setMenuOption(false)}>Tourist Security</Link></li>
                                    <li><Link to="/services/school-security/" onClick={() => setMenuOption(false)}>School Security</Link></li>
                                </ul>
                            </div>
                        )}
                    </div>
                    {/* MANPOWER Services */}
                    <div className="menu-group">
                        <div className="menu-item has-sub" onClick={() => toggleMenu("ManpowerServices")}>
                            MANPOWER SERVICES <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i>
                        </div>

                        {openMenu === "ManpowerServices" && (
                            <div className="submenu">
                                <li><Link to="/manpower-service/front-back-office-manpower/" onClick={() => setMenuOption(false)}>Front & Back office</Link></li>
                                <li><Link to="/manpower-service/temporary-staffing-solution/" onClick={() => setMenuOption(false)}>Temp Staffing</Link></li>
                                <li><Link to="/manpower-service/event-staff/" onClick={() => setMenuOption(false)}>Event Staff</Link></li>
                            </div>
                        )}
                    </div>

                    {/* Facility Services */}
                    <div className="menu-group">
                        <div className="menu-item has-sub" onClick={() => toggleMenu("FacilityServices")}>
                            FACILITY SERVICES <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i>
                        </div>

                        {openMenu === "FacilityServices" && (
                            <div className="submenu">
                                <li><Link to="/facility-service/corporate-housekeeping-service/" onClick={() => setMenuOption(false)}>HouseKeeping Services</Link></li>
                                <li><Link to="/facility-service/office-boy/" onClick={() => setMenuOption(false)}>Office Boy</Link></li>
                                <li><Link to="/facility-service/pantry-boy/" onClick={() => setMenuOption(false)}>Pantry Boy</Link></li>
                                <li><Link to="/facility-service/office-support-service" onClick={() => setMenuOption(false)}>Office Support Services</Link></li>
                            </div>
                        )}
                    </div>

                    <div className="menu-group">
                        <div className="menu-item"> <Link to="/our-clients" onClick={() => setMenuOption(false)}>OUR CLIENTS </Link></div>
                    </div>

                    <div className="menu-group">
                        <div className="menu-item"> <Link to="/gallery" onClick={() => setMenuOption(false)}>GALLERY</Link></div>
                    </div>
                    <div className="menu-group">
                        <div className="menu-item"> <Link to="/contact-us" onClick={() => setMenuOption(false)}>CONTACT US</Link></div>
                    </div>
                </div>
            )}
            <div className="container logo-container">
                <div className="row">
                    <div className="col-md-3 site-logo-web">
                        <div className="site-logo">
                            <Link to="/">
                                <img src="assets/img/site-logo.jpg" alt="site logo" />
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="header-right">
                            <div className="header-right-top">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="single-top-right">
                                            <p> Call Us: (+91) 9454311900</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="single-top-right">
                                            <ul>
                                                <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                                <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                                <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
                                                <li><a href="#"><i className="fa fa-google-plus"></i></a></li>
                                                <li><a href="#"><i className="fa fa-skype"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="single-top-right">
                                            <p><i className="fa fa-envelope"></i> info@octopusssecurity.com</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="menu-container">
                                <div className="row">
                                    <div className="col-md-11 col-sm-11">
                                        <div className="bleezy-responsive-menu"></div>
                                        <div className="mainmenu">
                                            <nav>
                                                <ul id="bleezy_navigation">
                                                    <li className="current-page-item menu-font"><Link to="/"> home</Link></li>
                                                    <li className='menu-font'><Link to="/About"> about us</Link></li>
                                                    <li>
                                                        <a href="#">security services  <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i> </a>
                                                        <ul>
                                                            <li><Link to="/services/security-guard/">Security Guard</Link></li>
                                                            <li><Link to="/services/bouncer-and-bodyguard/">Bouncer & Bodygruard</Link></li>
                                                            <li><Link to="/services/escort-guard/">Escort Guard</Link></li>
                                                            <li><Link to="/services/event-security/">Event Security</Link></li>
                                                            <li><Link to="/services/tourist-security/">Tourist Security</Link></li>
                                                            <li><Link to="/services/school-security/">School Security</Link></li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <a href="#">manpower services  <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i></a>
                                                        <ul>
                                                            <li><Link to="/manpower-service/front-back-office-manpower/">Front & Back office</Link></li>
                                                            <li><Link to="/manpower-service/temporary-staffing-solution/">Temp Staffing</Link></li>
                                                            <li><Link to="/manpower-service/event-staff/">Event Staff</Link></li>


                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <a href="#">facility services  <i class="fa fa-angle-down" style={{ fontSize: '15px' }}></i></a>
                                                        <ul>
                                                            <li><Link to="/facility-service/corporate-housekeeping-service/">HouseKeeping Services</Link></li>
                                                            <li><Link to="/facility-service/office-boy/">Office Boy</Link></li>
                                                            <li><Link to="/facility-service/pantry-boy/">Pantry Boy</Link></li>
                                                            <li><Link to="/facility-service/office-support-service">Office Support Services</Link></li>
                                                            {/* <li><Link to="/facility-service/canpactual-staffing-driver">Canpactual Staffing & Driver</Link></li> */}

                                                        </ul>
                                                    </li>
                                                    <li>

                                                        <Link to="/our-clients">our clients</Link>

                                                    </li>
                                                    <li>
                                                        <Link to="/gallery">gallery</Link>

                                                    </li>
                                                    <li><Link to="/contact-us">contact us</Link></li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;